export const cleanQNegozioName=value=>String(value||'').trim().replace(/^(?:ore\s+)?(?:[01]?\d|2[0-3])[:.][0-5]\d(?:\s*[-–—]\s*|\s+)(.+)$/i,'$1').trim();
const tokens = value => cleanQNegozioName(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().match(/[a-z]+/g)||[];
const key = value => tokens(value).sort().join(' ');
function similarity(a,b) {
  if(!a||!b)return 0;
  let previous=Array.from({length:b.length+1},(_,i)=>i);
  for(let i=1;i<=a.length;i++) {const row=[i];for(let j=1;j<=b.length;j++)row[j]=Math.min(row[j-1]+1,previous[j]+1,previous[j-1]+(a[i-1]===b[j-1]?0:1));previous=row;}
  return 1-previous[b.length]/Math.max(a.length,b.length);
}
export function patientSuggestions(name,patients) {
  const source=key(name),parts=tokens(name).filter(t=>t.length>2&&!['della','dello'].includes(t));
  if(!parts.length)return [];
  return patients.filter(p=>!p.qNegozioCustomerId).map(patient=>{
    const full=`${patient.firstName||''} ${patient.lastName||''}`,target=key(full);
    if(source===target)return {patient,score:1,reason:'Nome e cognome corrispondenti'};
    const targetParts=tokens(full),shared=parts.filter(t=>targetParts.includes(t)).length;
    const partial=shared===parts.length?.82:0;
    const fuzzy=similarity(source,target);
    return {patient,score:Math.max(partial,fuzzy),reason:partial>=fuzzy?'Nome parziale corrispondente':'Nome simile: verifica i dati'};
  }).filter(s=>s.score>=.68).sort((a,b)=>b.score-a.score||`${a.patient.lastName} ${a.patient.firstName}`.localeCompare(`${b.patient.lastName} ${b.patient.firstName}`,'it')).slice(0,3);
}
export const patientOptionLabel=p=>`${p.lastName||''} ${p.firstName||''}`.trim()+` · ${p.dateOfBirth?String(p.dateOfBirth).slice(0,10).split('-').reverse().join('/'):p.code||'Data di nascita non indicata'}`;
